"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.heartbeat = heartbeat;
var constants_1 = require("./constants");
function heartbeat(ws, lastMessageTime, options) {
    var _a = options || {}, _b = _a.interval, interval = _b === void 0 ? constants_1.DEFAULT_HEARTBEAT.interval : _b, _c = _a.timeout, timeout = _c === void 0 ? constants_1.DEFAULT_HEARTBEAT.timeout : _c, _d = _a.message, message = _d === void 0 ? constants_1.DEFAULT_HEARTBEAT.message : _d;
    var heartbeatInterval = setInterval(function () {
        if (lastMessageTime.current + timeout <= Date.now()) {
            console.warn("Heartbeat timed out, closing connection, last message was seen ".concat(Date.now() - lastMessageTime.current, "ms ago"));
            ws.close();
        }
        else {
            if (lastMessageTime.current + interval <= Date.now()) {
                try {
                    if (typeof message === 'function') {
                        ws.send(message());
                    }
                    else {
                        ws.send(message);
                    }
                }
                catch (err) {
                    console.error("Heartbeat failed, closing connection", err instanceof Error ? err.message : err);
                    ws.close();
                }
            }
        }
    }, interval);
    ws.addEventListener("close", function () {
        clearInterval(heartbeatInterval);
    });
    return function () { };
}
//# sourceMappingURL=heartbeat.js.map